import React, { Fragment } from 'react';
import { Redirect } from 'react-router';
import PropTypes from "prop-types";
import queryStringApp from "query-string";
import R from "ramda";
import { SearchParamsSyncWrapper } from './SearchParamsSyncWrapper.jsx';

export class DataProvider extends React.Component {
  static propTypes = {
    config: PropTypes.object.isRequired,
    render: PropTypes.func.isRequired,
    url: PropTypes.string.isRequired
  };

  state = {
    data: undefined,
    loading: true,
    error: undefined,
  };

  updateParams = changeObject => {
    const newRequestObject = this.state.data
      ? R.mergeDeepLeft(changeObject, this.state.data.request)
      : changeObject;

    if (this.state.data.request.sortBy !== newRequestObject.sortBy || this.state.data.request.perPage !== newRequestObject.perPage) {
      newRequestObject.page = 1;
    }

    this.fetchData(newRequestObject);
  };

  fetchData = newRequest => {
    const { config, url } = this.props;
    const { facetEndpoints } = config;
    const { data } = this.state;

    const queryString = newRequest
      ? newRequest
      : queryStringApp.parse(location.search);

    const hash = location.hash;
    const hashSign = location.href.search('#') != -1 && hash.length == 0 ? '#' : '';
    const pathname = location.pathname;

    this.setState({
      loading: true
    });

    queryString.page =
      queryString.page && queryString.page > 0 ? queryString.page : 1;
    queryString.perPage =
      queryString.perPage && queryString.perPage > 0 ? queryString.perPage : 50;

    if (!Array.isArray(queryString.facet)) {
      if (queryString.facet) {
        queryString.facet = new Array(queryString.facet);
      } else {
        if (
          pathname === "/books-chapters" ||
          pathname === "/books-and-chapters"
        ) {
          queryString.facet = ["book_type:Conference Volume"];
        } else {
          queryString.facet = [];
        }
      }
    }

    // Default for working paper.
    if (config.hasOwnProperty('searches') && config.searches === 'working_paper') {
      if ((typeof queryString.q === "undefined" || queryString.q == "")) {
        queryString.sortBy = 'public_date';
      } else {
        delete queryString.sortBy;
      }
    }

    if (config.defaultReqParams) {
      for (var i = 0; i < config.defaultReqParams.length; i++) {
        var param = config.defaultReqParams[i];
        var key = Object.keys(param)[0];
        queryString[key] = queryString[key] ? queryString[key] : param[key];
      }
    }
    const requestString = queryStringApp.stringify(queryString);

    let newUrl =
      window.location.origin +
      window.location.pathname +
      "?" +
      requestString +
      hashSign +
      hash;

    if (config.type == 'listing_alt') {
      newUrl = window.location.origin + window.location.pathname;
    }
    
    const apiUrl = url + "?" + requestString;

    // This seems to be unused (history.state is never referenced anywhere else). Commenting out for now since it interferes with Pager logic
    // const navigateBack = !newRequest && history.state;

    // if (!history.state || ((newRequest || !navigateBack) && (!R.equals(queryString,history.state)))) {
    //   if (!newRequest) {
    //     history.replaceState({ ...queryString }, "", newUrl);
    //   }
    //   else {
    //     history.pushState({ ...queryString }, "", newUrl);
    //   }
    // }

    fetch(apiUrl)
      .then(response => {
        return response.json();
      })
      .then(json => {
        const newJson = facetEndpoints
          ? R.mergeDeepLeft(R.mergeDeepLeft(json, { facets: data.facets }), {
              request: queryString
            })
          : R.mergeDeepLeft(json, { request: queryString });
          
        this.setState({
          data: newJson,
          loading: false,
        });
      });
  };

  fetchFacets = () => {
    const { facetEndpoints } = this.props.config;
    const thisProvider = this;

    if (facetEndpoints) {
      Promise.all(facetEndpoints.map(url => fetch(url)))
        .then(responses => Promise.all(responses.map(res => res.json())))
        .then(json => {
          const data = {
            facets: json,
            request: {},
            results: []
          };

          thisProvider.setState(
            {
              data: data
            },
            () => thisProvider.fetchData(null)
          );
        });
    } else {
      thisProvider.fetchData(null);
    }
  };

  componentDidMount = () => {
    this.fetchFacets();
    window.addEventListener("popstate", ()=>this.fetchData(null));
  };

  componentWillUnmount = () => {
    window.removeEventListener("popstate", ()=>this.fetchData(null));
  };

  render() {
    const { data, error, loading } = this.state;
    const updateParams = this.updateParams;

    if (error) {
      return (
        <div className="search">
          <div className="search__listing-container">There was an error loading this resource.</div>
        </div>
      );
    }

    /*
    if (loading) {
      return (
        <div className="search">
          <div className="search__listing-container">Searching...</div>
        </div>
      );
    }*/

    return (
      <Fragment>
        {data ? (
          <Fragment>
            {data.request && <SearchParamsSyncWrapper request={data.request}/>}
            {this.props.render({ data, loading, updateParams })}
          </Fragment>
        ) : (
          <div className="search">
            <div className="search__listing-container">No data available.</div>
          </div>
        )}
      </Fragment>
    );
  }
}
